import React, { useMemo, memo, useEffect } from 'react';
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import { useTypewriterEffect } from './useProcessor';

import styles from './index.module.scss';
import './index.scss';

interface P {
  text: string;
  showCursor: boolean;
  themeColor?: string;
  interrupt?: boolean;
  onComplete?: () => void;
  setChatting?: (value: boolean) => void,
}

const MarkDown: React.FC<P> = ({ 
  text, 
  showCursor = true, 
  themeColor,
  interrupt = false,
  onComplete,
  setChatting,
}) => {
  const { getRenderedText } = useTypewriterEffect({ text, showCursor, interrupt, onComplete });
  
  // 获取渲染文本（包含光标效果）
  const renderText = useMemo(() => {
    return getRenderedText(showCursor);
  }, [getRenderedText, showCursor]);
  
  return (
    <div id="scrollview" className={styles.MarkDownWrapper}>
      <div id="MarkDown" className={styles.MarkDown}>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
          components={{
            div: ({ node, ...props }) => <span style={{ color: '#5674F6' }} {...props} />,
            span: ({ node, ...props }) => <span style={{ color: '#5674F6' }} {...props} />,
          }}
        >
          {renderText}
        </ReactMarkdown>
      </div>
    </div>
  )
}

export default memo(MarkDown);
